import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
  VIEW_COLLECTION,
} from "../../../helper/constants";
import { removeLastPathNameFromSessionStorage } from "../../../helper/commonFunctions";
const BackToSearch = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const data = props.data;
  
  const handleBackToSearch = (e) => {
    e.preventDefault(); 
    const pathNames = JSON.parse(sessionStorage.getItem("pathNames") || "[]");
    if(pathNames.length > 1){
      removeLastPathNameFromSessionStorage();
    }else if(pathNames.length === 1){
      window.sessionStorage.removeItem("pathNames");
      window.sessionStorage.removeItem("breadCrumbSearchResultPageName");
    }
    navigate(-1); 
  };

  return (
    <div className="backtosearch">
      <Link
        to=""
        aria-label="PubTitle"
        className="backtosearchlink"
        state={data}
        onContextMenu={(e) => e.preventDefault()}
        onClick={(e) => handleBackToSearch(e)}
      >
        {t(VIEW_COLLECTION.BACK_SEARCH)}
      </Link>
    </div>
  );
};
export default BackToSearch;